module.exports = __webpack_public_path__ + "media/images/flags/64/Netherlands-ca0e6e274da7aedff37ebc3fb7c657bd.png";